import api from '../api/axios';
import { UserResponse } from '../types/auth';

export const authService = {
  /** Inicia sesión con usuario y contraseña. */
  login: async (username: string, password: string): Promise<UserResponse> => {
    const response = await api.post<UserResponse>('login/', { username, password });
    return response.data;
  },

  /** Cierra la sesión actual. */
  logout: async (): Promise<void> => {
    await api.post('logout/');
  },

  /** Devuelve el usuario autenticado (o lanza 401 si no hay sesión). */
  getCurrentUser: async (): Promise<UserResponse> => {
    const response = await api.get<UserResponse>('me/');
    return response.data;
  },
};
